import { BRAND_PAGE_REQUEST_EXCLUSIVITY_MODAL_TYPE } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { useBrandPageStateContext } from "@faire/retailer-visitor-shared/views/brand/contexts/BrandPageStateContext";
import { useBrand } from "@faire/retailer-visitor-shared/views/brand/hooks/useBrand";
import { useRetailerRestriction } from "@faire/retailer-visitor-shared/views/brand/hooks/useRetailerRestriction";
import { BrandPageModal } from "@faire/retailer-visitor-shared/views/brand/utils/enum";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { useLocation } from "react-router-dom";
export var useBrandPageModal = function() {
    var brand = useBrand();
    var retailerRestriction = useRetailerRestriction();
    var _useBrandPageStateContext = useBrandPageStateContext(), isFaireProtectionModalClosed = _useBrandPageStateContext.isFaireProtectionModalClosed, hasFaireProtection = _useBrandPageStateContext.hasFaireProtection;
    var queryParam = parseQueryParams(useLocation().search);
    if (!brand) {
        return undefined;
    }
    if (retailerRestriction) {
        return BrandPageModal.RESTRICTED;
    }
    if (hasFaireProtection && !isFaireProtectionModalClosed) {
        return BrandPageModal.ZIPCODE_PROTECTED;
    }
    if (queryParam.get("utm_source") === "brand_app" && queryParam.get("utm_medium") === "qr_code") {
        return BrandPageModal.SHARE_CONTACT_INFO;
    }
    if (queryParam.get("story")) {
        return BrandPageModal.STORY;
    }
    if (queryParam.get("contactUs")) {
        return BrandPageModal.CONTACT_MAKER;
    }
    if (queryParam.get("product")) {
        return BrandPageModal.UPDATE_CART;
    }
    if (queryParam.get("modalType") === "sampleRequest") {
        return BrandPageModal.SAMPLE_REQUEST;
    }
    if (queryParam.get("modalType") === BRAND_PAGE_REQUEST_EXCLUSIVITY_MODAL_TYPE) {
        return BrandPageModal.REQUEST_EXCLUSIVITY;
    }
    return undefined;
};
